// -------------------------------------------------------------------- constants --------------------------------------------------------------------

// ********************************************************************* financialGuardians **********************************************************************

const GET_ACTIVITY_LOG_SMS_SUCCESS = "GET_ACTIVITY_LOG_SMS_SUCCESS";
const GET_ACTIVITY_LOGS_SMS_SUCCESS = "GET_ACTIVITY_LOGS_SMS_SUCCESS";

// ----------------------------------------------------------------< action creators >----------------------------------------------------------------

// ********************************************************************* financialGuardians **********************************************************************
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _getLogSuccess(payload) {
  //  console.log(payload);
  return {
    type: GET_ACTIVITY_LOG_SMS_SUCCESS,
    payload: payload,
  };
}
/**
 *
 * @param {{data: Object}} payload
 * @return {{type: String, payload: Object}}
 * @private
 */
function _getLogsSuccess(payload) {
  //  console.log(payload);
  return {
    type: GET_ACTIVITY_LOGS_SMS_SUCCESS,
    payload: payload,
  };
}

// --------------------------------------------------------------------< actions >--------------------------------------------------------------------

// ********************************************************************* financialGuardians **********************************************************************
/**
 *
 * @param {number} [id={}]
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function getLog(id = null, params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (true) {
      api
        .get(`/Sms/GetSmsLogs`, { params })
        .then((res) => {
          dispatch(_getLogSuccess(res));
          callback(undefined, res);
        })
        .catch((err) => {
          callback(err && err.response);
        });
    } else {
      callback(undefined);
      app.message(
        app.translate(
          "routes.permission error",
          {
            permission: `${app.translate(
              "routes.home.basic.permission.activity-log",
              "activity-log"
            )} - ${app.translate(
              "routes.home.basic.permission.index",
              "index"
            )}`,
          },
          "permission error"
        ),
        "error"
      );
    }
  };
}
/**
 *
 * @param {Object} [params={}]
 * @param {Function} [callback=(function())]
 * @return {Function}
 */
export function getLogs(params = {}, callback = () => {}) {
  return (dispatch, gs, api) => {
    if (true) {
      api
        .get("/Sms/GetSmsLogs", { params })
        .then((res) => {
          dispatch(_getLogsSuccess(res));
          callback(undefined, res);
        })
        .catch((err) => {
          callback(err && err.response);
        });
    } else {
      callback(undefined);
      app.message(
        app.translate(
          "routes.permission error",
          {
            permission: `${app.translate(
              "routes.home.basic.permission.activity-log",
              "activity-log"
            )} - ${app.translate(
              "routes.home.basic.permission.index",
              "index"
            )}`,
          },
          "permission error"
        ),
        "error"
      );
    }
  };
}

// --------------------------------------------------------------------< reducer >--------------------------------------------------------------------
/**
 *
 * @param {Object} state
 * @param {{type: String, payload: Object}} action
 * @return {Object}
 */
export default function reducer(
  state = {
    log: {},
    logs: [],
    meta: {},
  },
  action
) {
  switch (action.type) {
    case GET_ACTIVITY_LOG_SMS_SUCCESS:
      return Object.assign({}, state, {
        logs: action.payload,
        meta: action.payload.data.meta,
      });
    case GET_ACTIVITY_LOGS_SMS_SUCCESS:
      return Object.assign({}, state, {
        logs: action.payload,
        meta: action.payload.data.meta,
      });
    default:
      return state;
  }
}
